import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, User, Home, Search } from 'lucide-react';
import { Button } from '../ui/button';
import { useCart } from '@/context/CartContext';
import { useAuth } from '@/context/AuthContext';
import { RestaurantStatusBanner } from './RestaurantStatusBanner';

export const Navbar = () => {
  const navigate = useNavigate();
  const { getTotalItems, setIsCartOpen } = useCart();
  const { user } = useAuth();
  const totalItems = getTotalItems();

  return (
    <>
      <RestaurantStatusBanner />
      <nav className="sticky top-0 z-40 glass-effect border-b border-border/50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
              <div>
                {/* Brand mark — kept as a <span> (not <h1>) so pages like
                    the SEO landing pages have exactly ONE <h1> per page.
                    The visual styling is unchanged. */}
                <span className="block text-xl font-bold text-foreground">Crispy Chicken</span>
                <p className="text-xs text-muted-foreground">Forfar</p>
              </div>
            </Link>

            <div className="hidden md:flex items-center space-x-4">
              <Button
                data-testid="cart-button"
                variant="ghost"
                size="icon"
                className="relative"
                onClick={() => setIsCartOpen(true)}
              >
                <ShoppingBag className="h-5 w-5" />
                {totalItems > 0 && (
                  <span className="absolute -top-1 -right-1 bg-primary text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                    {totalItems}
                  </span>
                )}
              </Button>
              {user ? (
                <Button
                  data-testid="profile-button"
                  variant="ghost"
                  size="icon"
                  onClick={() => navigate('/profile')}
                >
                  <User className="h-5 w-5" />
                </Button>
              ) : (
                <Button
                  data-testid="login-button"
                  onClick={() => navigate('/login')}
                  className="rounded-full"
                >
                  Login
                </Button>
              )}
            </div>
          </div>
        </div>
      </nav>

      <div className="md:hidden mobile-nav glass-effect">
        <div className="flex items-center justify-around h-16 px-4">
          <Button
            data-testid="mobile-home-button"
            variant="ghost"
            size="icon"
            onClick={() => navigate('/')}
          >
            <Home className="h-6 w-6" />
          </Button>
          <Button
            data-testid="mobile-search-button"
            variant="ghost"
            size="icon"
          >
            <Search className="h-6 w-6" />
          </Button>
          <Button
            data-testid="mobile-cart-button"
            variant="ghost"
            size="icon"
            className="relative"
            onClick={() => setIsCartOpen(true)}
          >
            <ShoppingBag className="h-6 w-6" />
            {totalItems > 0 && (
              <span className="absolute -top-1 -right-1 bg-primary text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {totalItems}
              </span>
            )}
          </Button>
          <Button
            data-testid="mobile-profile-button"
            variant="ghost"
            size="icon"
            onClick={() => navigate(user ? '/profile' : '/login')}
          >
            <User className="h-6 w-6" />
          </Button>
        </div>
      </div>
    </>
  );
};
